import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractDocumentAggregateTranslation.Save.IRequest;
type Response = Api.Core.ContractDocumentAggregateTranslation.Save.IResponse;
type Headers = Api.Core.ContractDocumentAggregateTranslation.Save.IHeaders;
const url = '/api/Sales/Contract/:id/DocumentAggregateTranslation/:languageIsoCode';
export default async function contractDocumentAggregateTranslationSaveApi(params: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params, undefined),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
